export default "__VITE_ASSET__8eac9b4b__"